import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { monthValueSelected } from '../../redux/common';

export default function useMonthSelectbox() {
  const INIT_VALUE = { label: '월', data: '' };
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(INIT_VALUE);

  // const year = useSelector(state => state.common.yearValue);

  const onOpen = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const onClick = useCallback((item) => {
    setValue(item);
    setOpen(false);

    dispatch(monthValueSelected(item));
  }, [value])

  const onReset = useCallback(() => {
    setOpen(false);
    setValue(INIT_VALUE);
    dispatch(monthValueSelected(INIT_VALUE));
  }, [open])

  return [open, value, onOpen, onClick, onReset];
}